import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import AnalysisPrintList from '@/views/RawDataManagement/AnalysisOfBusiness/printList.vue'

export default /*@__PURE__*/_defineComponent({
  __name: 'printList',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(AnalysisPrintList))
}
}

})